import React from 'react';

export const comparators = {
  recent: (a, b) => ((a.creationDate || a.date) < (b.creationDate || b.date) ? 1 : -1),
  highest: (a, b) => (a.rating < b.rating ? 1 : -1),
  lowest: (a, b) => (a.rating > b.rating ? 1 : -1),
};

export const getRatingsCount = (reviews) => {
  return reviews.reduce(
    (ratings, cur) => ({
      ...ratings,
      [cur.rating]: ratings[cur.rating] + 1,
    }),
    {
      0: 0,
      1: 0,
      2: 0,
      3: 0,
      4: 0,
      5: 0,
    }
  );
};

// rating sums is provided only for product data
// for shop data use comments
export const getReviewRatings = (styles, RatingComponent, ratingsSums, ratingsTotalNum, comments) => {
  const ratingsCount = ratingsSums || getRatingsCount(comments ? comments : [{ rating: 0 }]);

  const ratings = [1, 2, 3, 4, 5];

  return ratings.reverse().map((rating, index) => {
    const barWidthPerc = (100 * ratingsCount[rating]) / ratingsTotalNum;
    return (
      <div className={styles['ratingAmount']} key={index}>
        <RatingComponent value={rating} />
        <div className={styles['ratingBorder']}>
          <div
            className={styles['ratingBar']}
            style={{
              width: `${barWidthPerc}%`,
            }}
          ></div>
        </div>
        <span className={styles.ratingsCount}>{ratingsCount[rating]}</span>
      </div>
    );
  });
};

export const calculateReviewTime = (dateObj) => {
  const SECOND_IN_MILISECONDS = 1000;
  const MINUTE_IN_MILISECONDS = 60 * SECOND_IN_MILISECONDS;
  const HOUR_IN_MILISECONDS = 60 * MINUTE_IN_MILISECONDS;
  const DAY_IN_MILISECONDS = 24 * HOUR_IN_MILISECONDS;
  const WEEK_IN_MILISECONDS = 7 * DAY_IN_MILISECONDS;
  const MONTH_IN_MILISECONDS = 28 * DAY_IN_MILISECONDS;
  const YEAR_IN_MILISECONDS = 12 * MONTH_IN_MILISECONDS;

  if (dateObj / YEAR_IN_MILISECONDS >= 1) {
    return `${Math.round(dateObj / YEAR_IN_MILISECONDS)} year(s) ago`;
  }

  if (dateObj / MONTH_IN_MILISECONDS >= 1) {
    return `${Math.round(dateObj / MONTH_IN_MILISECONDS)} month(s) ago`;
  }

  if (dateObj / WEEK_IN_MILISECONDS >= 1) {
    return `${Math.round(dateObj / WEEK_IN_MILISECONDS)} week(s) ago`;
  }

  if (dateObj / DAY_IN_MILISECONDS >= 1) {
    return `${Math.round(dateObj / DAY_IN_MILISECONDS)} day(s) ago`;
  }

  if (dateObj / HOUR_IN_MILISECONDS >= 1) {
    return `${Math.round(dateObj / HOUR_IN_MILISECONDS)} hour(s) ago`;
  }

  if (dateObj / MINUTE_IN_MILISECONDS >= 1) {
    return `${Math.round(dateObj / MINUTE_IN_MILISECONDS)} minute(s) ago`;
  }

  if (dateObj / SECOND_IN_MILISECONDS >= 1) {
    return `${Math.round(dateObj / SECOND_IN_MILISECONDS)} second(s) ago`;
  }
};

export const ratingMicrodata = (shopInfo) => {
  if (shopInfo?.ratings?.votes > 0) {
    return `,
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "${shopInfo.ratings?.best_rating || 0}",
      "ratingCount": "${shopInfo.ratings?.votes}",
      "ratingValue": "${shopInfo.ratings?.original_rating}",
      "worstRating": "${shopInfo.ratings?.worst_rating || 0}"
    }`;
  }
  return '';
};
